
  import {Component, Vue} from "vue-property-decorator";
  import {ANONYMOUS_PAGE} from "@/modules/Auth/stores/auth.store";
  import {IBus} from "@/interfaces/bus-actions";
  import {bus} from "@/plugins/bus";
  import {IApp} from "@/interfaces/app.interface";
  import {isMobileOnly} from "mobile-device-detect";
  import {IAuth} from "@/modules/Auth/interfaces/auth.interface";
  import AntiTheftBtn from "@/modules/CarList/components/AntiTheftComponents/AntiTheftBtn.vue";
  import {antiTheftCars} from "@/modules/CarList/mixins/antitheft.class";

  @Component({
    components: {
      AntiTheftBtn,
    },
  })
  export default class AppMenuItemSettings extends Vue {

    collapseValue = null;
    isMobileOnly;

    get easyModeInterface() { return !this.$store.state.auth.userAccess.extModeFlag; }
    get userAccess(): IAuth.UserAccess { return this.$store.state.auth.userAccess; }
    get isUser() { return this.$store.state.auth.isUser; }
    get anonymous() { return this.$store.state.route.query[ANONYMOUS_PAGE] ? JSON.parse(this.$store.state.route.query[ANONYMOUS_PAGE]) : false; }

    get displaySettings() { return this.menuItems.some(action => action.displayCondition); }

    get menuItems() {
      let items = [
        {
          label: 'Парковки',
          command: IApp.ROUTE_NAME.PAGE_PARKS_CONFIG,
          icon: 'square-parking',
          displayCondition: !!(!this.easyModeInterface && this.userAccess && this.userAccess.parkMkFlag),
        }, {
          label: 'Доступ к парковке',
          command: IApp.ROUTE_NAME.PAGE_PARKING_ACCESS,
          icon: 'ico-access',
          displayCondition: !!(this.userAccess && this.userAccess.parkChoiceFlag),
        }, {
          label: 'Найти водителя',
          command: IApp.ROUTE_NAME.PAGE_FIND_DRIVER,
          icon: 'magnifying-glass',
          displayCondition: !!(this.userAccess && this.userAccess.scFindDriver),
        }, {
          command: 'AntiTheftBtn',
          specialTemplate: true,
          componentName: 'AntiTheftBtn',
          displayCondition: !!(!!this.userAccess.token && antiTheftCars && antiTheftCars.cars && antiTheftCars.cars.length),
          props: { 'main-menu': true, },
        }, {
          label: 'Корпорации',
          command: IApp.ROUTE_NAME.PAGE_CORPS,
          icon: 'people-roof',
          displayCondition: !!(this.userAccess && this.userAccess.scSettingsCorp),
        }, {
          label: 'Мониторинг',
          command: 'openPopup',
          icon: 'wrench',
          popupData: { block: 'allPages', popupName: 'deviceStatsPopup', },
          displayCondition: !!(this.userAccess && this.userAccess.scDeviceStats),
        },
      ];
      return items;
    }

    created() {
      this.isMobileOnly = isMobileOnly;
    }

    async commandAction(menuItem) {
      this.collapseValue = null;
      bus.$emit(IBus.AppMenuAction.Close);

      if (menuItem.command === 'AntiTheftBtn') return;
      else if (menuItem.command === 'openPopup') {
        await this.$store.dispatch('dialog/openDialog', {
          blockName: menuItem.popupData.block,
          dialogName: menuItem.popupData.popupName,
          payload: menuItem.popupData.payload || {}
        });
      }
      else {
        await this.$store.dispatch('openPage', {routeName: menuItem.command});
      }

    }
  }
